<script>
export default {
  name: "DidoExploreSortFilter",
};
</script>

<script setup>
import { ref } from "vue";

// define Props
const props = defineProps({
  sort: { type: String, required: true },
});

// Define Emits
const emit = defineEmits(["new-sort"]);

// define Reactive data
const sortInput = ref(props.sort);

// methods for transforming string (-)field to object { field, order }
const transformStringToObject = (str) => {
  if (str === "title") return { field: "title", sort: "asc" };
  if (str === "-title") return { field: "title", sort: "desc" };
  if (str === "last_modified") return { field: "last_modified", sort: "asc" };
  if (str === "-last_modified") return { field: "last_modified", sort: "desc" };
  return { field: "", sort: "" };
};
</script>

<template>
  <div class="row-start-center">
    <span class="text-underline q-mr-xs">Tri</span>
    <span class="q-mr-md">:</span>
    <!-- type options as Toggle Buttons -->
    <QBtnToggle
      v-model="sortInput"
      size="md"
      padding="sm"
      spread
      dense
      no-wrap
      unelevated
      toggle-color="secondary"
      text-color="secondary"
      class="dido-explore-filter-sortchoice-buttons no-border-radius"
      :options="[
        {
          value: '-last_modified',
          title:
            'Trier les résultats par date de modification décroissante (les plus récents en premier)',
          icon: 'mdi-sort-clock-descending-outline',
        },
        {
          value: 'last_modified',
          title:
            'Trier les résultats par date de modification croissante (les plus anciens en premier)',
          icon: 'mdi-sort-clock-ascending-outline',
        },
        {
          value: 'title',
          title: 'Trier les résultats par ordre alphabétique croissant',
          icon: 'mdi-sort-alphabetical-ascending',
        },
        {
          value: '-title',
          title: 'Trier les résultats par ordre alphabétique décroissant',
          icon: 'mdi-sort-alphabetical-descending',
        },
      ]"
      @update:model-value="emit('new-sort', transformStringToObject(sortInput))"
    />
  </div>
</template>
